//@flow

export const Entity = {};

export const Action = {
  Create: 'create',
  Edit: 'edit',
  Delete: 'delete',
};

export const Overviews = {};

export const Endpoints = {};

export const CustomerTypes = {
  RESIDENTIAL: "SOEResidential", // B2C Siebel
  SME: "SOEBusiness", // B2B SME Siebel
  MELODY: "MELODY", // B2B LE
  FUTUR_MICRO: "FUTUR_B2B_MICRO", // Prev ComHem
  FUTUR: "FUTUR", // Prev ComHem
  FUTUR_COMVIQ: "FUTUR_COMVIQ",
  CBS: "CBS", // Comviq
  INVALID_CUSTOMER_TYPE: "invalid-customer-type",
};

export const ToggleKeys = {
  VENDOR: {
    Apple: 'apple-',
    Samsung: 'samsung-'
  },
  ALL: {
    Apple: 'apple-all',
    Samsung: 'samsung-all'
  }
}

export const TransferSteps = {
  LOGIN: 1,
  CONFIRM: 2,
  DO_TRANSFER: 3,
  COMPLETE: 4,
}

export const ModalTypes = {
  PROMOTION: 'promotion',
  TERMS: 'terms',
}

export const VendorTypes = {
  SAMSUNG: 'Samsung',
  APPLE: 'Apple',
}
